class LanguageSwitcher {
    constructor() {
        this.languageSwitcher = document.querySelector('header .wpml-ls-legacy-list-horizontal');
        this.navigationContainer = document.querySelector('header .wp-block-navigation__container');
        this.postNavigationSection = document.querySelector('header .header__post-nav');
        this.events();
    }

    events() {
        // On load, if the viewport is 599px or less, move the language switcher to the navigation container
        if(window.innerWidth <= 599) {
            this.languageSwitcherToNavigation();
        }

        // On resize, if the viewport is 599px or less, move the language switcher to the navigation container
        window.addEventListener('resize', () => {
            if(window.innerWidth <= 599) {
                this.languageSwitcherToNavigation();
            } else {
                this.languageSwitcherToPostNavigation();
            }
        });
    }

    // Move the language switcher to the navigation container as the first element inside the ul
    languageSwitcherToNavigation() {
        this.navigationContainer.prepend(this.languageSwitcher);
    }

    // Move the language switcher to the post navigation section as the first element inside the div
    languageSwitcherToPostNavigation() {
        this.postNavigationSection.prepend(this.languageSwitcher);
    }

}

export default LanguageSwitcher;